export default __webpack_public_path__ + "static/media/152.77e43923.png";